import {Component, OnInit} from '@angular/core';
import {MenuItem, MenuItemCommandEvent} from "primeng/api";
import {Router} from "@angular/router";
import {UserData} from "projects/store/src/app/interfaces";
import {LocalStorageService} from "library";
import {LocalStorageKey, Permission} from "projects/store/src/app/enums";
import {PermissionService} from "projects/store/src/app/services/permission.service";

@Component({
  selector: 'app-tab-menu',
  templateUrl: './tab-menu.component.html'
})
export class TabMenuComponent implements OnInit{
  items: MenuItem[] | undefined;
  activeItem: MenuItem | undefined;
  userData: UserData;
  constructor(public router: Router,
              private localStorageService: LocalStorageService,
              private permissionService: PermissionService) {
    this.userData = this.localStorageService.get(LocalStorageKey.data);
  }

  ngOnInit() {
    const data = [
      { label: 'Dashboard', icon: 'pi pi-home', path: '/comisiones/dashboard', visible: this.permissionService.checkPermission(Permission['Gestion.Comercial.Dashboard']) },
      { label: 'Mis tiendas', icon: 'pi pi-map-marker', path: '/comisiones/mis-tiendas', visible: this.permissionService.checkPermission(Permission['Gestion.Comercial.MisTiendas']) },
      { label: 'Pagos', icon: 'pi pi-money-bill', path: '/comisiones/pagos', visible:  this.permissionService.checkPermission(Permission['Gestion.Comercial.Pagos']) },
      { label: 'Reportes', icon: 'pi pi-chart-bar', path: '/comisiones/reportes', visible:  this.permissionService.checkPermission(Permission['Gestion.Comercial.Reportes']) },
    ];

    let items: any[] = [];
    let activeIndex = 0;
    data.forEach(row => {
      if(row.path == this.router.url) {
        activeIndex = items.length;
      }
      items.push({
        label: row.label,
        icon: row.icon,
        visible: row.visible,
        command: (event: MenuItemCommandEvent) => {
          this.router.navigate([row.path])
        }
      });
    });

    this.items = items;
    this.activeItem = this.items[activeIndex];
  }

}
